<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2020-07-20 15:50:07
 * @LastEditors: mrh
 * @LastEditTime: 2020-12-09 14:05:49
--> 
<template>
  <section class="shareContent" v-show="showPopups">
    <div id="canvasImg" class="shareCanvas" ref="canvas">
      <canvas id="canvas"></canvas>
      <!-- <img src="../../assets/img/close.png" alt="" @click="cancel()"> -->
      <!-- <div style="width:282px;height:412px;background:#fff;"></div> -->
    </div>
    <div class="canvas-overlay" @click="cancel()"></div>
    <img src id="weChatImg" style="display: none" />
    <van-action-sheet
      cancel-text="取消"
      close-on-click-action
      v-model="showPopups"
      @cancel="cancel()"
      @click-overlay="cancel()"
      :overlay="false"
    >
      <p v-show="goodObj.sharePromotionContent && goodObj.shareMoney > 0">
        分享免费得同款商品及<span>{{ goodObj.shareMoney }}</span
        >元佣金
        <img src="../../assets/img/flowChart.png" alt="">
      </p>
      <p v-show="!goodObj.sharePromotionContent && goodObj.shareMoney > 0">
        分享得<span>{{ goodObj.shareMoney }}</span
        >元佣金<br/>
        好友订单完成后即可获得哦~
      </p>
      <p v-show="goodObj.sharePromotionContent && goodObj.shareMoney == 0">
        分享免费得同款商品
        <img src="../../assets/img/flowChart.png" alt="">
      </p>
      <div class="shareIcon">
        <div
          v-for="(item, index) in options"
          :key="index"
          @click="shareProduct(index)"
        >
          <img :src="item.icon" alt />
          <span>{{ item.name }}</span>
        </div>
      </div>
    </van-action-sheet>
    <van-overlay :show="showOverlay" class-name="share-overlay" z-index="9999">
      <div class="overlay-wrapper" @click.stop>
        <div class="overlay-block">
          <van-loading type="spinner" />
          <p>海报加载中...</p>
        </div>
      </div>
    </van-overlay>
  </section>
</template>

<script>
import wxPic from "@/assets/img/wx.png";
import pPic from "@/assets/img/pic.png";
import pyqPic from "@/assets/img/pyq.png";
import { uploadImageBase64,drawWxShare } from "@/api/join";
import gs from "@/assets/img/gs.png";
export default {
  name: "sharePopup",
  props: {
    goodObj: Object, //是否返回APP
    showPopup: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      options: [
        {
          name: "微信",
          icon: wxPic,
        },
        {
          name: "朋友圈",
          icon: pyqPic,
        },
        {
          name: "保存图片",
          icon: pPic,
        },
      ],
      // shareCommission: "分享给好友成功下单，过退款期限可获佣金",
      // getTwo: " 分享好友购买,元获得同款商品",
      imgUrl: "", //canvas生成的分享图
      goodPic: gs, //店铺分享主图
      invitePic: this.prefixURL + "mobile/img/mp/invite/inviteBoss.png", //邀请店长注册主图
      shareGoodsPic:'',//分享商品的主图
      showOverlay: true
    };
  },
  mounted() {
    // this.getCanvasImg();
  },
  methods: {
    getCanvasImg() {
      let myCanvas = document.getElementById("canvas"),
        cs = document.getElementById("canvasImg"),
        ctx = myCanvas.getContext("2d"),
        u = navigator.userAgent,
        that = this,
        ratio = that.getPixelRatio(ctx),
        isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

      if (window.outerHeight > 740) {
        //长条形的异形屏的canvas实际高度-40
        myCanvas.style.width = myCanvas.width + "px";
        myCanvas.style.height = myCanvas.height - 40 + "px";
        myCanvas.width = myCanvas.width * ratio;
        myCanvas.height = myCanvas.height * ratio;
        // 重新给外层div赋值
        cs.style.width = myCanvas.style.width;
      } else {
        // console.log(myCanvas.width, myCanvas.height);
        myCanvas.style.width = myCanvas.width + "px";
        myCanvas.style.height = myCanvas.height + "px";
        myCanvas.width = myCanvas.width * ratio;
        myCanvas.height = myCanvas.height * ratio;
      }
      //缩放画布
      ctx.scale(ratio, ratio);
      //  清理画布
      ctx.clearRect(0, 0, myCanvas.clientWidth, myCanvas.clientHeight);
      
      //   绘制矩形并填充色
      that.roundRect(
        0,
        0,
        that.xPxHandle(295),
        that.yPxHandle(405),
        10,
        "#fff",
        ctx
      );
      // 超出画布的区域不展示
      ctx.clip();
      /*
       * @param {String} memberId 推荐人id
       * @param {String} communityShopId 社区店id
       * @param {String} sellerProductGoodsId 商品id
       */
      let scene, paths;
      if (that.goodObj.shareType == 3) {
        scene = `${that.$store.getters.memberId}`;
      } else {
        scene = `${that.$store.getters.memberId},${
          that.$store.getters.communityShopId
        },${
          that.goodObj.sellerProductGoodsId == undefined
            ? "-1"
            : that.goodObj.sellerProductGoodsId
        }`;
      }
      // shareType 0商品分享 1店铺分享 2邀请店长注册 3邀请用户注册
      // console.log(scene);
      switch (that.goodObj.shareType) {
        case "0":
          paths = "pages/communityGoodsInfo/communityGoodsInfo";
          that.drawWxShare(that.goodObj.sellerProductGoodsId)
          // paths = "pages/bazaarIndex/bazaarIndex";
          break;
        case "1":
          paths = "pages/communitySaleIndex/communitySaleIndex";
          break;
        case "2":
          paths = "community/pages/goApplyBossApplet/goApplyBossApplet";
          break;
        case "3":
          paths = "pages/bazaarIndex/bazaarIndex";
          break;
      }
      let baseURL = that.prefixURL || "http://192.168.1.58:8080/app";
      // 利用img的src（get）请求获取流资源
      let wxQR = (document.getElementById(
        "weChatImg"
      ).src = `${baseURL}/comm/2_1/getWXQrcodeOfId?width=42&scene=${scene}&page=${paths}`);

      let img = new Image();
      img.setAttribute("crossOrigin", "Anonymous");
      switch (that.goodObj.shareType) {
        case "0":
          img.src = that.imgPrex + that.goodObj.imageUrl;
          break;
        case "1":
          img.src = that.goodPic;
          break;
        case "2":
          img.src = that.invitePic;
          break;
        case "3":
          img.src = that.invitePic;
          break;
      }
      img.onload = function () {
        ctx.drawImage(
          img,
          that.xPxHandle(10),
          that.yPxHandle(10),
          that.xPxHandle(275),
          that.yPxHandle(275)
        ); //绘制图片
        
        if (that.goodObj.shareType == 0) {
          // 绘制商品名
          ctx.font = "bold 14px Arial";
          ctx.fillStyle = "#1D1D1D";
          that.canvasWraptitleText(
            ctx,
            that.goodObj.name,
            that.xPxHandle(20),
            that.yPxHandle(305),
            that.xPxHandle(320),
            that.yPxHandle(20),
            1
          );
          // 绘制实际价格
          ctx.font = "bold 15px Arial";
          ctx.fillStyle = "#FF1310";
          let widths =
            that.goodObj.price.length > 6
              ? 24
              : that.goodObj.price.length > 5
              ? 16
              : that.goodObj.price.length > 4
              ? 8
              : that.goodObj.price.length > 3
              ? 2
              : 0;
          ctx.fillText(
            "￥" + that.goodObj.price,
            that.xPxHandle(20),
            that.yPxHandle(330)
          );
          // // 绘制线条，用于指导价划线
          ctx.strokeStyle = "#999";
          ctx.moveTo(that.xPxHandle(70 + widths), that.yPxHandle(325));
          ctx.lineTo(that.xPxHandle(108 + widths), that.yPxHandle(325));
          ctx.stroke();
          // 绘制指导价
          ctx.font = "12px Arial";
          // ctx.textBaseline = "alphabetic";
          ctx.fillStyle = "#999";
          ctx.fillText(
            "￥" + that.goodObj.guidePrice,
            that.xPxHandle(70 + widths),
            that.yPxHandle(329)
          );
        } else if (that.goodObj.shareType == 1) {
          ctx.font = "bold 14px Arial";
          ctx.fillStyle = "#333";
          that.canvasWraptitleText(
            ctx,
            that.goodObj.shopName,
            that.xPxHandle(20),
            that.yPxHandle(305),
            that.xPxHandle(320),
            that.yPxHandle(20),
            1
          );
          ctx.font = "12px Arial";
          ctx.fillStyle = "#208fff";
          ctx.fillText(
            that.goodObj.name,
            that.xPxHandle(20),
            that.yPxHandle(330)
          );
        } else if (that.goodObj.shareType == 2 || that.goodObj.shareType == 3) {
          ctx.font = `bold 12px Arial`;
          ctx.fillStyle = "#333";
          ctx.fillText(
            "做悦买店长，开启0成本创业第一步",
            that.xPxHandle(20),
            that.yPxHandle(301)
          );
        }
        ctx.font = `bold 12px Arial`;
        ctx.fillStyle = "#1d1d1d";
        ctx.fillText(
          that.goodObj.shareType == 0
            ? "长按识别购买商品"
            : that.goodObj.shareType == 1
            ? "长按识别进入社区店"
            : that.goodObj.name,
          that.xPxHandle(74),
          that.yPxHandle(357)
        );
        ctx.font = `12px Arial`;
        ctx.fillStyle = "#333333";
        that.drawText(
          ctx,
          that.goodObj.shareType == 2 || that.goodObj.shareType == 3
            ? "邀请您成为悦买店长"
            : "好友推荐您来享受悦买商品的优惠啦～",
          that.xPxHandle(74),
          that.yPxHandle(377),
          that.xPxHandle(220),
          that.yPxHandle(16.5)
        );
      };
      let imgQR = new Image();
      imgQR.setAttribute("crossOrigin", "Anonymous");
      imgQR.src = wxQR;
      imgQR.onload = function () {
        // ctx.fillText("好友推荐您来享受悦买商品的优惠啦～", 84, 370);
        ctx.drawImage(
          imgQR,
          that.xPxHandle(20),
          that.yPxHandle(340),
          that.xPxHandle(44),
          that.yPxHandle(44)
        );
        // console.log(myCanvas.toDataURL);
        let strDataURI = myCanvas.toDataURL(0.1);
        that.getWeChatCodeImg(strDataURI.split(",")[1]);
      };
      ctx.save();
    },
    // 获取分享图片链接
    getWeChatCodeImg(code) {
      uploadImageBase64({
        fileContent: code,
        //参数
      }).then((res) => {
        // OnSuccess function
        this.imgUrl = res.content.path;
        this.showOverlay = false;
      });
    },

    //处理canvas的x轴||width的px单位
    xPxHandle(pxs) {
      //不同分辨率下不同的宽度
      //pxs--原始单位
      let myCanvas = document.getElementById("canvas"),
        ctx = myCanvas.getContext("2d");
      return Math.round(
        ((myCanvas.width / this.getPixelRatio(ctx)) * pxs) / 295
      );
    },
    //处理canvas的y轴||height的px单位
    yPxHandle(pxs) {
      //不同分辨率下不同的宽度
      //pxs--原始单位
      let myCanvas = document.getElementById("canvas"),
        ctx = myCanvas.getContext("2d");
      return Math.round(
        ((myCanvas.height / this.getPixelRatio(ctx)) * pxs) / 405
      );
    },
    // 自适应绘制多行文字
    /**
     * @param {Object} ctx canvas上下文
     * @param {String} text 需要输入的文本
     * @param {Number} x X轴起始位置
     * @param {Number} y y轴起始位置
     * @param {Number} maxWidth 单行最大宽度
     * @param {Number} lineHeight 行高
     */
    drawText(ctx, text, x, y, maxWidth, lineHeight) {
      let canvas = ctx.canvas;
      let arrText = text.split("");
      let line = "";
      for (let n = 0; n < arrText.length; n++) {
        let testLine = line + arrText[n];
        let metrics = ctx.measureText(testLine);
        let testWidth = metrics.width;
        if (testWidth > maxWidth && n > 0) {
          ctx.fillText(line, x, y);
          line = arrText[n];
          y += lineHeight;
        } else {
          line = testLine;
        }
      }
      ctx.fillText(line, x, y);
    },

    // canvas画圆角矩形封装函数
    /**
     * @param {Object} x x轴坐标点
     * @param {String} y y轴坐标点
     * @param {Number} w 画布宽度
     * @param {Number} h 画布高度
     * @param {Number} r 圆角弧度
     * @param {Number} col 填充色
     * @param {Number} ctx 画布对象
     */
    roundRect(x, y, w, h, r, col, ctx) {
      if (w < 2 * r) r = w / 2;
      if (h < 2 * r) r = h / 2;
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.fillStyle = col; //填充色
      ctx.fill();
      // ctx.strokeStyle = borcol; //边框色
      ctx.closePath();
    },
    // canvas绘制文本超出显示省略号
    /**
     * @param {String} canvas 对象
     * @param {String} text 文本
     * @param {Object} x x轴坐标点
     * @param {String} y y轴坐标点
     * @param {Number} maxWidth 画布宽度
     * @param {Number} lineHeight 画布高度
     * @param {Number} maxRowNum 最大行数
     */
    canvasWraptitleText(canvas, text, x, y, maxWidth, lineHeight, maxRowNum) {
      if (
        typeof text != "string" ||
        typeof x != "number" ||
        typeof y != "number"
      ) {
        return;
      }
      // canvas.font = "14px Bold PingFang SC"; //绘制文字的字号和大小
      // 字符分隔为数组
      var arrText = text.split("");
      var line = "";
      var rowNum = 1;
      for (var n = 0; n < arrText.length; n++) {
        var testLine = line + arrText[n];
        var metrics = canvas.measureText(testLine);
        var testWidth = metrics.width;
        if (testWidth > maxWidth && n > 0) {
          if (rowNum >= maxRowNum) {
            var arrLine = testLine.split("");
            arrLine.splice(-9);
            var newTestLine = arrLine.join("");
            newTestLine += "...";
            canvas.fillText(newTestLine, x, y);
            //如果需要在省略号后面添加其他的东西，就在这个位置写（列如添加扫码查看详情字样）
            //canvas.fillStyle = '#2259CA';
            //canvas.fillText('扫码查看详情',x + maxWidth-90, y);
            return;
          }
          canvas.fillText(line, x, y);
          line = arrText[n];
          y += lineHeight;
          rowNum += 1;
        } else {
          line = testLine;
        }
      }
      canvas.fillText(line, x, y);
    },
    getPixelRatio(context) {
      var backingStore =
        context.backingStorePixelRatio ||
        context.webkitBackingStorePixelRatio ||
        context.mozBackingStorePixelRatio ||
        context.msBackingStorePixelRatio ||
        context.oBackingStorePixelRatio ||
        context.backingStorePixelRatio ||
        1;
      return (window.devicePixelRatio || 1) / backingStore;
    },

    cancel() {
      // console.log("342");
      //  let myCanvas = document.getElementById("canvas");
      //  myCanvas.width = 1;
      //  myCanvas.height = 1;
      this.$emit("hidePopup", false);
      //   this.showPopups = false
    },
    shareProduct(type) {
      if (this.imgUrl == "") {
        return;
      }
      // console.log(this.goodObj)
      let shareType = this.goodObj.shareType;
      let title = "";
      let goodsImg = "";
      if (this.goodObj.shareType == 0) {
        title = `【￥${this.goodObj.price}】${this.goodObj.name}`;
        goodsImg = this.imgPrex + this.shareGoodsPic;
      } else if(this.goodObj.shareType == 1 || this.goodObj.shareType == 3) {
        title = `你的好友${this.goodObj.name}邀您参与团购，万千好物，一起团，更优惠`;
        goodsImg = this.prefixURL + "mobile/img/mp/myShopShare.png";
      }else {
        title = `你的好友${this.goodObj.name}邀您成为店长，轻松月入过万`;
        goodsImg = this.prefixURL + "mobile/img/mp/invite/inviteApplyBoss.png";
      }
      let imgUrl = type == 0 ? goodsImg : this.imgPrex + this.imgUrl;
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //微信环境
        wx.miniProgram.getEnv(function (res) {
          if (res.miniprogram) {
            //小程序环境下逻辑
          } else {
            //非小程序环境下逻辑
          }
        });
      } else {
        //非微信环境逻辑
        let u = navigator.userAgent,
          app = navigator.appVersion;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let isOS = isAndroid ? true : false;
        if (isOS) {
          // Android环境
          window.Android.shareCommunity(
            imgUrl,
            title,
            shareType,
            type,
            this.$store.getters.communityShopId,
            this.goodObj.sellerProductGoodsId
          );
        } else {
          // ios环境
          /**
           * @param {} imgUrl 分享图路径
           * @param {} title 分享文本
           * @param {} shareType 分享类型 0-商品  1-店铺  2-邀请店长注册 3-邀请用户注册 4-排行榜
           * @param {} type  点击类型 0-微信分享 1-微信朋友圈  2-保存图片
           * @param {} communityShopId 店家id
           * @param {} sellerProductGoodsId 商品id
           */
          // window.webkit.messageHandlers.getShare.postMessage
          window.webkit.messageHandlers.shareCommunity.postMessage({
            imgUrl: imgUrl,
            title: title,
            shareType: shareType,
            type: type.toString(),
            communityShopId: this.$store.getters.communityShopId,
            sellerProductGoodsId: this.goodObj.sellerProductGoodsId,
          });
        }
      }
    },

    // 获取微信小程序卡片分享的主图
    drawWxShare(spgId){
      drawWxShare({spgId}).then(res=>{
        if (res.appStatus.errorCode == 0) {
          this.shareGoodsPic = res.content.url
        }
      })
    }
  },
  computed: {
    showPopups: {
      get: function () {
        return this.showPopup;
      },
      set: function () {},
    },
    // showPopups(){
    //     return this.showPopup
    // }
  },
  watch: {
    showPopup: {
      handler(newV, oldV) {
        if (newV) {
          setTimeout(() => {
            var clientWidth = document.documentElement.clientWidth;
            var clientHeight =
              window.outerHeight > 740
                ? document.documentElement.clientHeight - 40
                : document.documentElement.clientHeight;
            let c = document.getElementById("canvas");
            let ctx = c.getContext("2d");
            //根据设计图中的canvas画布的占比进行设置
            // 590/810 -- 设计稿ui弹窗的实际宽度   750/1334  ---设计稿的高度
            var canvasWidth = Math.floor((clientWidth * 590) / 750);
            var canvasHeight = Math.floor((clientHeight * 810) / 1334);
            // 动态设置canvas宽度，兼容不同分辨率
            c.setAttribute("width", canvasWidth + "px");
            c.setAttribute("height", canvasHeight + "px");
            this.getCanvasImg();
            // console.log(this.goodObj)
          }, 20);
          this.showOverlay = newV;
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.shareContent {
  width: 100%;
  height: 100%;
  .shareCanvas {
    // background: #f5f5f5;
    width: 295px;
    height: 405px;
    position: fixed;
    z-index: 2002;
    top: calc((50% - 150px) / 2);
    left: 0;
    right: 0;
    margin: 0 auto;
    transform: translateY(calc((-50% + 140px) / 2));
    // img{
    //   width: 24px;
    //   height: 24px;
    //   position: absolute;
    //   top: -20px;
    //   right: -20px;
    // }
  }
  .canvas-overlay {
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.5;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2001;
  }
  //   /deep/.van-overlay {
  //     z-index: 330 !important;
  //   }
  /deep/.van-action-sheet {
    border-radius: 0;
    .van-action-sheet__content {
      > p {
        color: #333;
        font-size: 12px;
        text-align: center;
        margin: 10px auto 0;
        span {
          color: #ff1310;
        }
        img{
          width: 345px;
          height: 28px;
          display: block;
          margin: 10px auto 0;
        }
      }
      .shareIcon {
        display: flex;
        //   padding: 15px 33px;
        justify-content: space-around;
        > div {
          display: flex;
          flex-flow: column;
          align-items: center;
          img {
            width: 51px;
            height: 51px;
          }
          span {
            font-size: 14px;
            color: #666;
          }
        }
      }
    }
    .van-action-sheet__gap {
      height: 1.04px;
    }
    .van-action-sheet__cancel {
      height: 49px;
    }
  }
  /deep/.van-loading__spinner {
    width: 32px;
    height: 32px;
  }
  .share-overlay{
    background: none;
    .overlay-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      .overlay-block {
        width: 109px;
        height: 106px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: #000000;
        opacity: 0.64;
        border-radius: 5px;
        p{
          margin-top: 15px;
          font-size: 12px;
          color: #FFFFFF;
        }
      }
    }
  }
}
</style>